/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Related_ToolsInputs */

const en_guide_related_tools = /** @type {(inputs: Guide_Related_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try These Tools`)
};

const ko_guide_related_tools = /** @type {(inputs: Guide_Related_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도구를 사용해 보세요`)
};

const ja_guide_related_tools = /** @type {(inputs: Guide_Related_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらのツールを試す`)
};

/**
* | output |
* | --- |
* | "Try These Tools" |
*
* @param {Guide_Related_ToolsInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_related_tools = /** @type {((inputs?: Guide_Related_ToolsInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Related_ToolsInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_related_tools(inputs)
	if (locale === "ko") return ko_guide_related_tools(inputs)
	return ja_guide_related_tools(inputs)
});